/** Shared constants and helpers used across Dashboard, AuditLogs, and Client CRM pages. */

// -- Offer status --

export const STATUS_COLORS: Record<string, string> = {
  bozza: '#9CA3AF',
  inviata: '#3B82F6',
  accettata: '#10B981',
  rifiutata: '#EF4444',
  scaduta: '#F59E0B',
};

export const STATUS_LABELS: Record<string, string> = {
  bozza: 'Bozza',
  inviata: 'Inviate',
  accettata: 'Accettate',
  rifiutata: 'Rifiutate',
  scaduta: 'Scadute',
};

// -- Audit action --

export const ACTION_COLORS: Record<string, string> = {
  create: 'bg-green-100 text-green-800',
  update: 'bg-blue-100 text-blue-800',
  delete: 'bg-red-100 text-red-800',
  login: 'bg-purple-100 text-purple-800',
  logout: 'bg-gray-100 text-gray-800',
  send: 'bg-yellow-100 text-yellow-800',
  accept: 'bg-emerald-100 text-emerald-800',
  reject: 'bg-orange-100 text-orange-800',
};

export const ACTION_LABELS: Record<string, string> = {
  create: 'Creazione',
  update: 'Modifica',
  delete: 'Eliminazione',
  login: 'Accesso',
  logout: 'Uscita',
  send: 'Invio',
  accept: 'Accettazione',
  reject: 'Rifiuto',
};

export const RESOURCE_LABELS: Record<string, string> = {
  offerta: 'Offerta',
  cliente: 'Cliente',
  user: 'Utente',
  template: 'Template',
  tenant: 'Tenant',
};

// -- Currency formatting --

export const formatCurrency = (value: number): string =>
  new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(value);

export const formatCurrencyCompact = (value: number): string =>
  new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value);
